var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "link_menu fr is_m_show",
      attrs: { href: this.downloadConsoleAppLink, target: "_blank" }
    },
    [
      _c("span", { staticClass: "menu_txt" }, [
        _vm._v(_vm._s(_vm.$t("AppDownload")))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }